import React from "react";

import LanguageSelector from "../LanguageSelector";

function BannerCopy(props) {
  const { restaurantName, applicationType } = props;

  // const handleLanguageChange = event => {
  //   dispatch(setLanguage(event.target.value));
  //   dispatch(fetchMenuItems(event.target.value));
  // };

  return (
    <div className="ls-banner">
      {applicationType && applicationType === "MENU_TEST" && (
        <>
          <div className="restaurant-name">{restaurantName}</div>
          <LanguageSelector />
        </>
      )}
    </div>
  );
}

export default BannerCopy;
